package team.platforma.chat_data.model

import org.koin.core.scope.ScopeID

data class ChatData(
    val id: Long,
    val aiModelId: Long,
    val userId: Long,
    val name: String
)
